import { render, staticRenderFns } from "./AIAssessmentCreation.vue?vue&type=template&id=0c09420c&scoped=true"
import script from "./AIAssessmentCreation.vue?vue&type=script&lang=ts"
export * from "./AIAssessmentCreation.vue?vue&type=script&lang=ts"
import style0 from "./AIAssessmentCreation.vue?vue&type=style&index=0&id=0c09420c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c09420c",
  null
  
)

export default component.exports